import Card from "./Card"
import CardH from "./CardH"
import BotonesPedidos from "./BotonesPedidos"
import BotonesEstado from "./BotonesEstado"
export default {
    Card,
    CardH,
    BotonesPedidos,
    BotonesEstado
}